import type { Localized } from '../types/funnel';

/** Legal identity used on legal pages, consent disclosures and the footer. Do not add addresses, licenses or badges that are not verified. */
export const business = {
  legalName: 'InstaMovers Florida LLC',
  siteTitle: 'Florida Local Movers',
  website: 'https://floridalocalmovers.instamoversfl.com',
  email: 'instamoversfl@gmail.com',
  phoneDisplay: '+1 (656) 268-0800',
  phoneHref: 'tel:+16562680800',
};

export const legalPaths = {
  privacy: '/privacy-policy',
  terms: '/terms-and-conditions',
};

export const ownershipLine: Localized = {
  en: 'Florida Local Movers is a moving service website operated by InstaMovers Florida LLC.',
  es: 'Florida Local Movers es un sitio web de servicios de mudanza operado por InstaMovers Florida LLC.',
};

export const legalLinkLabels = {
  privacy: { en: 'Privacy Policy', es: 'Política de Privacidad' } as Localized,
  terms: { en: 'Terms & Conditions', es: 'Términos y Condiciones' } as Localized,
};
